<template>
  <q-page class="bg-white">

    <q-card class="my-card" flat>
      <q-img
        :src="configTemplate_mainBackground"
        placeholder-src="hero-results-compressed-small.jpg"
        no-spinner
        alt=""
        height="250px">
        <div class="hero fit col wrap justify-center items-center content-center text-blur">

          <q-skeleton v-if="event === null" type="text" tag="div" style="width: 50%; height: 5vh" animation="fade"></q-skeleton>
          <div v-else class="text-h1 text-center text-primary font-title">{{ eventName }}</div>

          <q-skeleton v-if="event === null" type="text" tag="div" style="width: 30%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h5 text-center">{{ organizerName }}</div>

          <q-skeleton v-if="event === null" type="text" tag="div" style="width: 70%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h6 text-center">{{eventDate}}</div>
        </div>
      </q-img>
    </q-card>


    <div class="q-pa-md-md q-pa-sm q-pb-xl ios-mobile">


      <div class="full-width row wrap justify-between q-mb-md bg-grey-4 q-pa-xs" style="border-radius: 20px">
        <q-btn rounded no-caps color="primary" icon="fa-solid fa-caret-left" size="sm" :label="$t('live.events.back')" :to="{name: 'LiveEvents'}" />
        <q-btn rounded no-caps color="primary" size="sm" :label="$t('live.event.documents')" :to="{name: 'LiveDocuments', params: {event_id: $route.params.event_id}}" />

      </div>

      <div class="full-width row items-center content-center">


        <q-markup-table flat class="col-12" v-if="event === null">
          <thead>
          <tr>
            <th class="text-left" style="width: 150px">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
            <th class="text-right">
              <q-skeleton animation="blink" type="text" />
            </th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="n in 5" :key="n">
            <td class="text-left">
              <q-skeleton animation="blink" type="text" width="85px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="50px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="35px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="65px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="25px" />
            </td>
            <td class="text-right">
              <q-skeleton animation="blink" type="text" width="85px" />
            </td>
          </tr>
          </tbody>
        </q-markup-table>

        <div v-if="event && event.status === 'open'" class="col-12">
        <q-list class="col-12 q-mb-lg"
                v-for="(shows, date) in event.shows"
                :key="`event-show-${date}`"
        >

          <q-expansion-item
            dark default-opened
            header-class="expansion-item"
            expand-separator
            :label="formatDate(date)"
          >
            <q-card>
              <q-card-section class="q-pa-none">

                <div v-for="(show, indexShow) in shows" :key="`event-show-${indexShow}`">
                  <q-item :class="indexShow%2 === 0 && 'line-even'" v-if="show.entries > 0">

                    <q-item-section top>
                      <q-item-label lines="1">
                        <span class="text-weight-medium" v-if="event.federation === 'fei'">{{ show.name }}</span>
                        <span class="text-weight-medium" v-else>{{ show.id }} / {{ show.name }}</span>
                      </q-item-label>

                      <q-item-label caption lines="1" v-if="event.type === 'cso' && show.can_access">
                        <span>{{ $t('live.event.bareme') }}: {{ show.settings.bareme }}</span>
                      </q-item-label>

                      <q-item-label caption lines="1" v-if="show.team_rule === true">
                        <span>{{ $t('live.event.teams') }}: {{ show.teams }}</span>
                      </q-item-label>
                      <q-item-label caption lines="1" v-else>
                        <span>{{ $t('live.event.entries') }}: {{ show.entries }} <q-badge color="red" v-if="show.live">En cours</q-badge></span>
                        <showProgress :event_id="event.id" :show_id="show.id" v-if="show.entries > 0 && eventType && ['dressage', 'cce', 'derby_cross', 'derby_eventing', 'hunter', 'cso'].includes(eventType)" class="q-mt-sm"></showProgress>
                      </q-item-label>
                    </q-item-section>

                    <q-item-section side v-if="show.can_access">
                      <div class="q-gutter-xs text-weight-bold text-primary">


                        <q-btn class="gt-xs" no-caps rounded unelevated outline color="grey-5" text-color="primary" size="sm" :label="$t('live.event.timetable')" :to="{name: 'LiveTimetable', params: {event_id: event.id, number: show.id}}" />

                        <q-btn no-caps color="primary" rounded unelevated size="sm" :label="$t('live.event.results')" :to="{name: 'LiveRanking', params: {event_id: event.id, number: show.id}}" />

                      </div>
                    </q-item-section>
                  </q-item>
                </div>


              </q-card-section>
            </q-card>
          </q-expansion-item>


          <q-item v-if="event && event.shows.length === 0">
            <q-item-section class="fit column wrap text-center justify-center items-center content-center">
            <q-icon name="fa-light fa-file-alt" class="q-mt-lg" size="xl"></q-icon><br />
              {{ $t('live.event.no-shows') }}
            </q-item-section>
          </q-item>

        </q-list>
        </div>

        <div v-if="event && event.status === 'archive'" class="col-12 text-center">
          <q-icon name="fa-light fa-box-archive" size="lg"></q-icon>
          <p>{{ $t('live.event.archive') }}</p>
        </div>

        <div v-if="event && event.status === 'cancel'" class="col-12 text-center">
          <q-icon name="fa-duotone fa-calendar-xmark" size="lg" class="q-ma-md"></q-icon>
          <p>{{ $t('live.event.cancel') }}</p>
        </div>

        <div v-if="event && event.status === 'calendrier'" class="col-12 text-center">
          <q-icon name="fa-duotone fa-calendar-days" size="lg" class="q-ma-md"></q-icon>
          <p>{{ $t('live.event.calendar') }}</p>
        </div>

      </div>

    </div>
  </q-page>
</template>

<script>
import {
  parsed,
} from '@quasar/quasar-ui-qcalendar'
import { defineComponent, ref } from 'vue';
import { useMeta } from "quasar";
import {useStore} from "vuex";
import ShowProgress from "components/ShowProgress";

export default defineComponent({
  name: 'LiveEvent',
  components: {
    ShowProgress
  },
  data () {
    return {
      title: ref(this.$i18n.t('system.loading')),
      meta_description: '',
      meta_ldJson: `{ "@context": "http://schema.org" }`,
    }
  },
  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath }) {
    // fetch data, validate route and optionally redirect to some other route...
    // load event
    return store.dispatch("event/getEvent", currentRoute.params.event_id)

    // ssrContext is available only server-side in SSR mode

  },
  computed: {
    eventName() {
      if (this.event) {
        return this.event.name
      }
      else
        return null
    },
    organizerName() {
      if (this.event) {
        return this.event.organizer.name
      }
      else
        return null
    },
    eventType() {
      if (this.event) {
        return this.event.type
      }
      else
        return null
    },
    eventTypeLabel() {

      if (!this.event)
        return null

      switch (this.event.type) {
        case 'cce':
          return this.$i18n.t('events.type.cce')
        case 'cso':
          return this.$i18n.t('events.type.cso')
        case 'dressage':
          return this.$i18n.t('events.type.dressage')
        case 'hunter':
          return this.$i18n.t('events.type.hunter')
        case 'derby_cross':
          return this.$i18n.t('events.type.derby_cross')
        case 'derby_eventing':
          return this.$i18n.t('events.type.derby_eventing')
        case 'crossindoor':
          return this.$i18n.t('events.type.crossindoor')
        default:
          return this.event.type
      }
    },
    eventDate() {

      if (this.event) {
        if (this.event.date.start === this.event.date.end)
          return this.formatDate(this.event.date.start)
        else {
          return this.$i18n.t('live.event.date-from') + ' ' + this.formatDate(this.event.date.start) + ' ' + this.$i18n.t('live.event.date-to') + ' ' + this.formatDate(this.event.date.end)
        }
      }

      return ''
    },
    configTemplate_mainBackground() {
      if (this.configTemplate !== null && this.configTemplate.main_color) {
        return 'hero-results-compressed-tpl-' + this.configTemplate.main_color + '.jpg'
      }

      return 'hero-results-compressed-small.jpg'
    }
  },
  methods: {
    formatDate(dateInput) {
      const dateValue = parsed(dateInput + ' 00:00')
      return dateValue.day.toString().padStart(2, '0') + '/' + dateValue.month.toString().padStart(2, '0')  + '/' + dateValue.year.toString()
    },
  },
  setup () {

    const $store = useStore()
    const event = $store.getters["event/eventGetter"]

    const configTemplate = $store.getters["organizer/organizerTemplateGetter"]
    const customDomain = (configTemplate !== null)

    return {
      configTemplate,
      customDomain,
      event,
    }
  },
  created: function () {

    if (this.event === null) {
      this.$router.replace({ path: '/404' }, 404)
    }

    if (this.event) {
      this.title = this.event.name
      this.meta_description = this.$i18n.t('live.event.discover') + ' ' + this.$i18n.t('live.event.organizedby') + ' ' + this.event.organizer.name

      // meta
      let ldJson = {"@context": "http://schema.org"}

      ldJson["@type"] = 'SportsEvent'
      ldJson["name"] = this.event.name
      ldJson["description"] = this.meta_description
      ldJson["url"] = process.env.VUE_APP_URL + this.$route.path

      ldJson["isAccessibleForFree"] = true
      ldJson["eventAttendanceMode"] = 'OfflineEventAttendanceMode'

      ldJson["identifier"] = {}
      ldJson["identifier"]["@type"] = "PropertyValue"
      ldJson["identifier"]["propertyID"] = "N° FFE"
      ldJson["identifier"]["value"] = this.event.federation_number

      if (this.event.status === 'cancel')
        ldJson["eventStatus"] = 'https://schema.org/EventCancelled'
      else
        ldJson["eventStatus"] = 'https://schema.org/EventScheduled'

      ldJson["offers"] = {}
      ldJson["offers"]["@type"] = "Offer"
      ldJson["offers"]["price"] = "0.00"
      ldJson["offers"]["priceCurrency"] = "EUR"

      ldJson["organizer"] = {}
      ldJson["organizer"]["@type"] = "Organization"
      ldJson["organizer"]["name"] = this.event.organizer.name


      ldJson["startDate"] = this.event.date.start
      ldJson["endDate"] = this.event.date.end

      ldJson["image"] = process.env.VUE_APP_URL + '/cover.jpg'


      ldJson["location"] = {}
      ldJson["location"]["@type"] = 'Place'
      ldJson["location"]["address"] = {}
      ldJson["location"]["address"]["@type"] = "PostalAddress"
      ldJson["location"]["address"]["postalCode"] = this.event.organizer.location.zip_code
      ldJson["location"]["address"]["addressLocality"] = this.event.organizer.location.city
      ldJson["location"]["name"] = this.event.organizer.name

      this.meta_ldJson = JSON.stringify(ldJson)

      useMeta(() => {
        return {
          // whenever "title" from above changes, your meta will automatically update
          title: this.title,
          meta: {
            title: {content: this.title},
            ogTitle: {content: this.title},
            ogUrl: {content: this.$router.currentRoute._value.href},
            twitterUrl: {content: this.$router.currentRoute._value.href},
            twitterTitle: {content: this.title},
            ogDescription: {content: this.meta_description},
            twitterDescription: {content: this.meta_description},
            description: {name: 'description', content: this.meta_description},
          },
          script: {
            ldJson: {
              type: 'application/ld+json',
              innerHTML: this.meta_ldJson
            }
          }
        }
      })
    }
  },
  mounted: function () {
  },
})
</script>

<style scoped>
.table-challenge  ::v-deep(tr):nth-child(even) {
  background-color: #f3f3f4;
}
.table-challenge ::v-deep(tr):nth-child(odd) {
  background-color: #fdfdfd;
}

.table-challenge ::v-deep(td) {
  border-color: transparent;
  height: 30px;
}

.hero .text-h5, .hero .text-h6 {
  color: #272727;
  font-weight: initial;
}

.hero {
  background: none;
}
</style>


